/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiTemplateField } from './BridgeApiTemplateField';
import {
    BridgeApiTemplateFieldFromJSON,
    BridgeApiTemplateFieldFromJSONTyped,
    BridgeApiTemplateFieldToJSON,
    BridgeApiTemplateFieldToJSONTyped,
} from './BridgeApiTemplateField';

/**
 * a Template
 * @export
 * @interface BridgeApiTemplate
 */
export interface BridgeApiTemplate {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplate
     */
    handle: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplate
     */
    categoryHandle: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplate
     */
    messageValue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiTemplate
     */
    customMessage: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiTemplate
     */
    chat: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiTemplate
     */
    responseComment: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiTemplate
     */
    customRequestFields: boolean;
    /**
     * 
     * @type {Array<BridgeApiTemplateField>}
     * @memberof BridgeApiTemplate
     */
    requestedFields: Array<BridgeApiTemplateField>;
    /**
     * 
     * @type {Array<BridgeApiTemplateField>}
     * @memberof BridgeApiTemplate
     */
    providedFields: Array<BridgeApiTemplateField>;
    /**
     * 
     * @type {Array<BridgeApiTemplateField>}
     * @memberof BridgeApiTemplate
     */
    recipientConclusionFields: Array<BridgeApiTemplateField>;
    /**
     * 
     * @type {Array<BridgeApiTemplateField>}
     * @memberof BridgeApiTemplate
     */
    senderConclusionFields: Array<BridgeApiTemplateField>;
}

/**
 * Check if a given object implements the BridgeApiTemplate interface.
 */
export function instanceOfBridgeApiTemplate(value: object): value is BridgeApiTemplate {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categoryHandle' in value) || value['categoryHandle'] === undefined) return false;
    if (!('customMessage' in value) || value['customMessage'] === undefined) return false;
    if (!('chat' in value) || value['chat'] === undefined) return false;
    if (!('responseComment' in value) || value['responseComment'] === undefined) return false;
    if (!('customRequestFields' in value) || value['customRequestFields'] === undefined) return false;
    if (!('requestedFields' in value) || value['requestedFields'] === undefined) return false;
    if (!('providedFields' in value) || value['providedFields'] === undefined) return false;
    if (!('recipientConclusionFields' in value) || value['recipientConclusionFields'] === undefined) return false;
    if (!('senderConclusionFields' in value) || value['senderConclusionFields'] === undefined) return false;
    return true;
}

export function BridgeApiTemplateFromJSON(json: any): BridgeApiTemplate {
    return BridgeApiTemplateFromJSONTyped(json, false);
}

export function BridgeApiTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'name': json['name'],
        'categoryHandle': json['categoryHandle'],
        'messageValue': json['messageValue'] == null ? undefined : json['messageValue'],
        'customMessage': json['customMessage'],
        'chat': json['chat'],
        'responseComment': json['responseComment'],
        'customRequestFields': json['customRequestFields'],
        'requestedFields': ((json['requestedFields'] as Array<any>).map(BridgeApiTemplateFieldFromJSON)),
        'providedFields': ((json['providedFields'] as Array<any>).map(BridgeApiTemplateFieldFromJSON)),
        'recipientConclusionFields': ((json['recipientConclusionFields'] as Array<any>).map(BridgeApiTemplateFieldFromJSON)),
        'senderConclusionFields': ((json['senderConclusionFields'] as Array<any>).map(BridgeApiTemplateFieldFromJSON)),
    };
}

export function BridgeApiTemplateToJSON(json: any): BridgeApiTemplate {
    return BridgeApiTemplateToJSONTyped(json, false);
}

export function BridgeApiTemplateToJSONTyped(value?: BridgeApiTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'name': value['name'],
        'categoryHandle': value['categoryHandle'],
        'messageValue': value['messageValue'],
        'customMessage': value['customMessage'],
        'chat': value['chat'],
        'responseComment': value['responseComment'],
        'customRequestFields': value['customRequestFields'],
        'requestedFields': ((value['requestedFields'] as Array<any>).map(BridgeApiTemplateFieldToJSON)),
        'providedFields': ((value['providedFields'] as Array<any>).map(BridgeApiTemplateFieldToJSON)),
        'recipientConclusionFields': ((value['recipientConclusionFields'] as Array<any>).map(BridgeApiTemplateFieldToJSON)),
        'senderConclusionFields': ((value['senderConclusionFields'] as Array<any>).map(BridgeApiTemplateFieldToJSON)),
    };
}

